export const CHARACTER_LINKS_TO_YT = {
	PURPOSEFULNESS: "https://youtu.be/JAWxR-cHiDY",
	HOPE: "https://youtu.be/r0-PU9UN8gU",
	TRUTHFULNESS: "https://youtu.be/n6t0NtVFry8",
	LOVE: "https://youtu.be/4fnRWYH1fq4",
	RESPECT: "https://youtu.be/8kk-424Lhhs",
	MINDFULNESS: "https://youtu.be/ZsVXzoj14GM",
	WISDOM: "https://youtu.be/3IBe_BiDtBY",
	TRUSTWORTHINESS: "https://youtu.be/KkZqJYJfsew",
	COMPASSION: "https://youtu.be/4z2h3jFcPq0",
	COURAGE: "https://youtu.be/AtCBYq_VQ8c",
	TOLERANCE: "https://youtu.be/Hykxd48O8uE",
	"SELF-DISCIPLINE": "https://youtu.be/xdndgR9dZx8"
};

export const CHARAMETRICS_LINKS_TO_YT = "https://youtu.be/v9IOsJ7iFeE";
